import React, { useState, useEffect } from "react";
import { Row, Col, Card, Tabs, Button, MenuProps, Dropdown, message } from "antd";
import BreadCrumb from "../../../atoms/BreadCrumb";
import DashboardLayout from "../../../molecules/DashboardLayout";
import Overview from "./components/Overview";
import Dependants from "./components/Dependants";
import Documents from "./components/Documents";
import Lease from "./components/Lease";
import Tickets from "./components/Tickets";
import Payments from "./components/Payments";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getTenantDetails, emptyTenantDetail } from "./ducks/actions";
import { leaseStatement } from "./ducks/services";
import { getPresignedImage } from "../../../../utils/media";
import PdfView from "../../../molecules/PDFViewer/pdvViewNew";
import { VehicleDetails } from "./components/vehicle-detail";

export default (props) => {
  const [tabKey, setTabkey] = useState("0");
  const { id } = useParams();
  const dispatch: any = useDispatch();
  const tenantData = useSelector((state: any) => state.tenantsSummary.tenantData);
  const [menuitems, setMenuItems] = useState([]);
  const [viewOrDownloadUrl, setViewOrDownloadUrl] = useState(null);
  const [openFileView, setOpenFileView] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  var _ = require("lodash");

  //@ts-ignore
  useEffect(() => {
    getTenants();
    return () => dispatch(emptyTenantDetail());
  }, []);

  const getTenants = () => {
    dispatch(getTenantDetails(id));
  };
  const userAccess = JSON.parse(localStorage.getItem("login-response"));

  const checkRights = () => {
    if (
      userAccess?.accessibleScreens &&
      userAccess?.accessibleScreens?.length > 0 &&
      !userAccess?.accessibleScreens?.includes("tenants")
    ) {
      return false;
    } else {
      return true;
    }
  };

  const tabs = [
    {
      label: "Overview",
      children: <Overview getTenants={getTenants} userId={id} />,
      key: "0",
    },
    {
      label: "Documents",
      children: <Documents tenantData={tenantData} />,
      key: "1",
    },
    {
      label: "Lease",
      children: <Lease showSelection={false} tenantData={tenantData} />,
      key: "2",
    },
    {
      label: "Co-Occupants",
      children: <Dependants tenantData={tenantData} />,
      key: "3",
    },
    {
      label: "Tickets",
      children: <Tickets tenantData={tenantData} />,
      key: "4",
    },
    {
      label: "Payments",
      children: <Payments tenantData={tenantData} />,
      key: "5",
    },
    ...(Boolean(tenantData?.vehicleDetail?.activeLease)
      ? [{ label: "Vehicle Details", children: <VehicleDetails />, key: "6" }]
      : []),
  ];

  const breadcrumbList: any = [
    {
      label: "Tenants",
      route: checkRights() ? "/tenants" : "",
    },
    {
      label: tenantData?.userDetail?.name ?? "",
      route: "",
    },
  ];

  useEffect(() => {
    let temp = [{ label: "All", key: "all", disabled: true }];
    _.map(tenantData?.leaseDetail, (item) => {
      const property = item?.propertyDetails;
      temp.push({
        label: `${property?.unitCode} ${property?.propertyName}`,
        key: item?.leaseId,
        disabled: false,
      });
    });

    tenantData?.leaseDetail?.length > 0 ? setMenuItems(temp) : setMenuItems([]);
  }, [tenantData]);

  const getUrl = async (data) => {
    // *****
    // type 1 mean view document
    // and 2 mean view in edit mode
    // ***

    try {
      const url = await getPresignedImage([data]);

      if (url[0]) {
        return url[0];
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error, "error");
    }
  };

  const getLeaseStatement = async () => {
    setOpenFileView(true);
    setIsLoading(true);
    try {
      let response = await leaseStatement(id);
      if (response) {
        const getFileUrl: any = await getUrl(response?.documentId);

        if (getFileUrl) {
          setViewOrDownloadUrl(getFileUrl);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          message?.error("Document not found");
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error, "getLeaseStatement");
    }
  };

  const handleMenuClick = (e) => {
    e.key !== "all" && setOpenFileView(true);
    // e.key !== "all" && getLeaseStatement(e.key);
  };

  const items: MenuProps["items"] = menuitems;

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  return (
    <>
      <DashboardLayout>
        <Row gutter={[24, 24]} className="mb-2">
          <Col span={18}>
            <BreadCrumb list={breadcrumbList} />
          </Col>
          {/* {menuitems?.length > 0 && ( */}
          <Col span={6}>
            <div style={{ display: "flex", justifyContent: "end" }}>
              {/* <Dropdown menu={menuProps} placement="bottomLeft">
                 <Button className="ef-approve-btn" type="primary">
            Print Statement
          </Button>
                </Dropdown> */}

              <Button onClick={() => getLeaseStatement()} className="ef-approve-btn" type="primary">
                Print Statement
              </Button>
            </div>
          </Col>
          {/* )} */}
        </Row>

        <Row gutter={24} className="managers_tenants_detail">
          <Col span={24}>
            <Card bordered={false} className="ag-nospace-head ag-nospace-body h-auto">
              <Tabs defaultActiveKey={tabKey} onChange={setTabkey} tabBarGutter={16} items={tabs} />
            </Card>
          </Col>
        </Row>
      </DashboardLayout>

      <PdfView
        pdfData={viewOrDownloadUrl}
        openFileView={openFileView || props?.sendSettlementReport}
        setOpenFileView={setOpenFileView}
        isLoading={isLoading}
        closable={true}
      />
    </>
  );
};
